export default "__VITE_ASSET__C10$PjTm__"